import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import I18nMarkdown from '../../../Common/i18nMarkdown';

const Question = ({ show, hidden, name, help, showHelp, setShowHelperQuestion, children, labelHelp, showLabel }) =>
  !hidden && show ? (
    <div className="question">
      <div className={cn('grid-1', { show: showLabel, hide: !showLabel })}>
        <div className="name">{name}</div>
        {help && (
          <div className="help">
            <div
              className="head"
              role="button"
              tabIndex="0"
              onKeyDown={setShowHelperQuestion}
              onClick={setShowHelperQuestion}
            >
              {labelHelp}
            </div>
            {showHelp && (
              <div className="body">
                <I18nMarkdown string={help} defaultValue={help} />
              </div>
            )}
          </div>
        )}
      </div>
      <div className="grid-2">{children}</div>
    </div>
  ) : (
    ''
  );

Question.propTypes = {
  name: PropTypes.string.isRequired,
  show: PropTypes.bool,
  hidden: PropTypes.bool,
  help: PropTypes.string,
  showHelp: PropTypes.bool,
  setShowHelperQuestion: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  labelHelp: PropTypes.string,
  showLabel: PropTypes.bool,
};

Question.defaultProps = {
  show: false,
  hidden: false,
  help: '',
  showHelp: false,
  labelHelp: 'En savoir plus...',
  showLabel: true,
};

export default Question;
